<eo-base-form-control
  [label]="getLabel()"
  [help]="getHelp()"
  [errors]="getErrors()"
>
  <p-calendar
    styleClass="w-full {{ getDatePickerStyleClass() }}"
    iconDisplay="input"
    [id]="id"
    [tabindex]="getTabIndex()"
    [placeholder]="getPlaceholder()"
    [formControl]="getFormControl()"
    [showClear]="getShowClear()"
    [showIcon]="getShowIcon()"
    [showButtonBar]="getShowButtonBar()"
    [appendTo]="getAppendTo()"
    [showOnFocus]="getShowOnFocus()"
    (onSelect)="onSelect($event)"
    (onFocus)="focus.emit($event)"
    (onBlur)="blur.emit($event)"
    [dateFormat]="getDateFormat()"
    [minDate]="getMinDate()"
    [maxDate]="getMaxDate()"
  >
    <ng-template pTemplate="clearicon">
      <i class="pi pi-times pointer-events-none"></i>
    </ng-template>
    <ng-template pTemplate="inputicon">
      <i
        *ngIf="handleIconChange() | async"
        class="pi pi-{{ getIcon() }} pointer-events-none"
      ></i>
    </ng-template>
    <ng-content />
  </p-calendar>
</eo-base-form-control>
